function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#72a7cf"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.7 440.9 c-4.9 -2.8 -4.7 4.1 -4.7 -184.9 0 -190 -0.2 -182.2 4.8 -184.9 1.5 -0.8 28.1 -1.1 87.2 -1.1 l85.1 0 2.4 2.5 c2.4 2.3 2.5 2.8 2.5 17 l0 14.5 122.3 0 c81.6 0 123.4 0.4 125.9 1.1 6.8 1.8 6.8 2 6.8 44.4 l0 37.5 34.4 0 c33.2 0 34.4 0.1 37 2.1 2 1.6 2.6 2.9 2.6 5.7 -0.1 2 -16.2 57.5 -36 123.2 -31.4 104.5 -36.2 119.8 -38.5 121.7 l-2.6 2.3 -213.7 0 c-150.1 -0.1 -214.2 -0.4 -215.5 -1.1z m39.7 -131.4 c13.8 -38.3 24.5 -66.8 25.7 -68 1.9 -1.9 3.5 -2 61.3 -2.3 l59.4 -0.2 23.3 -24.3 c12.8 -13.3 24.2 -25 25.3 -25.9 2 -1.6 8.3 -1.8 91.4 -1.8 l89.2 0 0 -32.5 0 -32.5 -124.5 -0.2 -124.5 -0.3 -2.7 -2.8 c-2.8 -2.7 -2.8 -2.9 -3.1 -17.2 l-0.3 -14.5 -73.5 0 -73.4 0 0.1 147.8 c0 123.5 0.3 147.1 1.4 144.2 0.7 -1.9 11.9 -33.2 24.9 -69.5z"
}));

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.44d46907.svg";
export { ForwardRef as ReactComponent };